import React from "react";
import Spinner from "../presentationals/Spinner";
import { roundToTwo } from "../../utils/common/index";
import { triggerDashboardAudit } from "../../redux/actions";
import { useSelector } from "react-redux";

export const CustomSalesCard = (props) => {
  const { filterValue } = useSelector((state) => state.homeReducer);

  const sendAudit = () => {
    const obj = {
      headers: {
        url: "/add-dashboard-audit",
      },
      params: {
        action: "download",
        dashboard: props.dashboardName,
        empId: filterValue?.agentId?.length
          ? filterValue?.agentId
          : filterValue?.orgId,
        empRole: filterValue.partnerName,
        remarks: "Dashboard Audit request",
        userType: filterValue?.site,
        viewName: props.viewName,
      },
    };
    triggerDashboardAudit(obj);
  };

  function csvHandler(e) {
    e.preventDefault();
    sendAudit();
    props.csvDownload(props.csvName);
  }

  // Combined card layout when multiple values are provided (Qty + Value + % or Qty + %)
  if (
    props.achieved !== undefined &&
    (props.valueUnit !== undefined || props.percentAchieved !== undefined)
  ) {
    return (
      <div className={`col-md-${props.col ? props.col : "4"} `}>
        <div
          data-cy="display-card"
          style={{ minHeight: "fit-content" }}
          className={`d-flex roundborder staticHeightSales mb-2 whiteoverlaycir payoutgrad${props.gradient}`}
        >
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "space-between",
              height: "fit-content",
            }}
          >
            {/* Quantity Section */}
            <div
              className="leftcont"
              style={{ flex: "1", minWidth: "150px", marginRight: "10px" }}
            >
              <div style={{ display: "flex", flexDirection: "column" }}>
                <span
                  className="text-white fw-bold "
                  style={{ marginBottom: "5px" }}
                >
                  Quantity
                </span>
                <span className="text-dark fw-bold">
                  Ach : {roundToTwo(props.achieved)}
                </span>
                <span className="text-dark fw-bold">
                  Target : {roundToTwo(props.target)}
                </span>
                {props.lmtdQty !== undefined && (
                  <span className="text-dark fw-bold">
                    LMTD : {roundToTwo(props.lmtdQty)}
                  </span>
                )}
                {props.percentAchieved !== undefined && (
                  <span className="text-dark fw-bold">
                    % Ach : {roundToTwo(props.percentAchieved).toFixed(2)}
                  </span>
                )}
              </div>
            </div>
            {/* Value Section - only shown when valueUnit is provided */}
            {props.valueUnit !== undefined && (
              <div
                className="leftcont"
                style={{ flex: "1", minWidth: "150px", marginRight: "10px" }}
              >
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <span
                    className="text-white fw-bold"
                    style={{ marginBottom: "5px" }}
                  >
                    Value in ₹{props.unit && ` ${props.unit}`}
                  </span>
                  <span className="text-dark fw-bold">
                    Val : {roundToTwo(props.valueUnit).toFixed(2)}
                  </span>
                  {props.lmtdVal !== undefined && (
                    <span className="text-dark fw-bold">
                      LMTD : {roundToTwo(props.lmtdVal).toFixed(2)}
                    </span>
                  )}
                  {props.percentAchieved !== undefined && (
                    <span className="text-dark fw-bold">
                      % Ach : {roundToTwo(props.percentAchieved).toFixed(2)}
                    </span>
                  )}
                </div>
              </div>
            )}
          </div>
          <div className="clearfix" style={{ width: "100%", minHeight: 24 }}>
            <span className="float-right" style={{ float: "right" }}>
              {props.csvDownload &&
                (props.loading && props.loading[props.csvName] ? (
                  <div
                    style={{
                      float: "right",
                      width: "40px",
                    }}
                  >
                    <Spinner showAlert={false} />
                  </div>
                ) : (
                  <span className="downloadarrow">
                    <button
                      type="button"
                      data-cy={props.csvName}
                      className="btn btn-link p-0"
                      onClick={csvHandler}
                    >
                      <img
                        src={
                          process.env.PUBLIC_URL +
                          "/assets/images/icons/download-arrow-w.svg"
                        }
                        alt="download-arrow"
                      />
                    </button>
                  </span>
                ))}
            </span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className={`col-md-${props.col ? props.col : "4"} `}>
        <div
          data-cy="display-card"
          style={{ minHeight: "fit-content" }}
          className={`roundborder staticHeightSales mb-2 whiteoverlaycir payoutgrad${props.gradient}`}
        >
          <div className="clearfix" style={{ width: "100%", minHeight: 24 }}>
            <span className="float-right" style={{ float: "right" }}>
              {props.csvDownload &&
                (props.loading && props.loading[props.csvName] ? (
                  <div
                    style={{
                      float: "right",
                      width: "40px",
                    }}
                  >
                    <Spinner showAlert={false} />
                  </div>
                ) : (
                  <span className="downloadarrow">
                    <button
                      type="button"
                      data-cy={props.csvName}
                      className="btn btn-link p-0"
                      onClick={csvHandler}
                    >
                      <img
                        src={
                          process.env.PUBLIC_URL +
                          "/assets/images/icons/download-arrow-w.svg"
                        }
                        alt="download-arrow"
                      />
                    </button>
                  </span>
                ))}
            </span>
          </div>
          <div>
            {props.achieved ? (
              <div className="leftcont w-100">
                {props.tileName.includes("/") ? (
                  <>
                    <div
                      style={{
                        display: "flex",
                        flexWrap: "wrap",
                        justifyContent: "space-between",
                      }}
                    >
                      <div style={{ display: "flex", marginRight: "20px" }}>
                        <span className="text-dark fw-bold">
                          {props.tileName.split("/")[0]} :{" "}
                        </span>
                        &nbsp;{`${roundToTwo(props.achieved)}`}
                      </div>
                      {props.csvName === "simAct" && (
                        <div style={{ display: "flex", marginRight: "20px" }}>
                          <span className="fw-bold">%Ach : </span>
                          {`${
                            +props.target === 0
                              ? "0"
                              : roundToTwo(
                                  (+props.achieved * 100) / +props.target,
                                )
                          }`}
                        </div>
                      )}
                    </div>
                    <div style={{ display: "flex" }}>
                      <span className="text-dark fw-bold">
                        {props.tileName.split("/")[1]} :{" "}
                      </span>
                      &nbsp;{`${roundToTwo(props.target)}`}
                    </div>
                  </>
                ) : (
                  <>
                    {`${roundToTwo(props.achieved)}/${roundToTwo(
                      props.target,
                    )}`}
                    <span className="text-dark fw-bold">{props.tileName}</span>
                  </>
                )}
                {props.lmtd && (
                  <span className="text-dark fw-bold">
                    LMTD : {roundToTwo(props.lmtd)}
                  </span>
                )}
              </div>
            ) : props.unit ? (
              <div className="leftcont">
                {roundToTwo(props.value).toFixed(2)}
                <span className="text-dark fw-bold">
                  {props.tileName}
                  {props.unit}
                </span>
                {props.lmtd && (
                  <span className="text-dark fw-bold">
                    LMTD : {roundToTwo(props.lmtd).toFixed(2)}
                  </span>
                )}
              </div>
            ) : (
              <div className="leftcont">
                {roundToTwo(props.value).toFixed(2)}
                <span className="text-dark fw-bold">{props.tileName}</span>
                {props.lmtd && (
                  <span className="text-dark fw-bold">
                    LMTD : {roundToTwo(props.lmtd)}
                  </span>
                )}
              </div>
            )}
            {/* <div className="rsdmap"><img src={process.env.PUBLIC_URL+`/assets/images/${props.image}.png`} alt="image4" /></div> */}
          </div>
        </div>
      </div>
    </>
  );
};
